import LegalSection from "./legal-section";

export {
  LegalSection
}



// WEBPACK FOOTER //
// src/common/legal-section/index.js